import { render, staticRenderFns } from "./DmIcon.vue?vue&type=template&id=7a41dc9e"
import script from "./DmIcon.vue?vue&type=script&lang=js"
export * from "./DmIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports